import { homeResponsivePhotos } from "@/data/homeResponsivePhotos";

/** Layout sizes stay at the call site; other pages retain original delivery. */
export function homePhotoProps(src: string, sizes: string) {
  const photo = homeResponsivePhotos[src];
  return photo ? { srcSet: photo.srcSet, sizes, width: photo.width, height: photo.height } : {};
}
export const HOME_GRID_SIZES = "(min-width: 1400px) 435px, (min-width: 1024px) calc((100vw - 96px) / 3), (min-width: 640px) calc((100vw - 72px) / 2), calc(100vw - 32px)";
export const HOME_HALF_SIZES = "(min-width: 1400px) 660px, (min-width: 1024px) calc((100vw - 88px) / 2), (min-width: 640px) calc(100vw - 48px), calc(100vw - 32px)";
